import React, {Component} from 'react';
import {Card, CardBody, CardTitle, Col, Row} from 'reactstrap';
import FormSection from './FormSection.js';

class ProjectForm extends Component {
	render() {
		console.log(this.props.projectFields);
		return (
			<Col sm={this.props.colsize}>
				<br />
				<Card className="standard-form border-0">
					<h2 id="projectHeader" className="h2 mb-3">{this.props.title}</h2>
					<CardBody>
						<Row>
							<Col xs={4} className="project-customer">
								<FormSection
									title="Property / Project"
									fields={this.props.projectFields}
								/>
								<FormSection
									title="Billing"
									fields={this.props.billingFields}
								/>
							</Col>
							<Col xs={4} className="project-financial">
								<FormSection
									title="Fees / Financial"
									fields={this.props.financeFields}
								/>
								<FormSection
									title="Management"
									fields={this.props.managementFields}
								/>
							</Col>
							<Col xs={4} className="project-contact">
								<FormSection
									title="Contact Info"
									fields={this.props.contactFields}
								/>
								<FormSection
									title="Kickoff"
									fields={this.props.kickoffFields}
								/>
								<FormSection
									title="Shipping"
									fields={this.props.shippingFields}
								/>
							</Col>
						</Row>
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default ProjectForm;



// WEBPACK FOOTER //
// ./src/components/ProjectForm.js